import React from "react";

const LoadingRows = () => {
    return (
        <div className="loading_container">
            <div className="header_loading fade-in"></div>
            <div className="bottom_loading_row fade-in">
                {Array.from({ length: 5 }).map((_, index) => (
                    <div key={index} className="bottom_loading_share"></div>
                ))}
            </div>
        </div>
    );
};

export default LoadingRows;
